import { Tag } from "antd";

export default function LogisticsPackagingTag() {
  return <Tag>Logistics packaging</Tag>;
}
